'use strict';

import React from 'react'

import { search, capitalize } from '@root/utility'

import Layout   from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import SearchBar from '@Pure/SearchBar'
import Link      from '@Pure/Link'
import Image     from '@Pure/Image'
import Loader    from '@Pure/Loader'
import Logo      from '@Pure/Logo'

import stripTags from 'striptags'

const moment = window.moment;

let app = window.app;

export default class MeetingRecordsPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			data: [],
			references: [],
			pagination:
			{
				max_items: 30,
				limit: 30,
				skip: 0
			},
			searched:
			{
				value: ''
			}
		};

		this.handleSessionChange = this.handleSessionChange.bind(this);
		this.fetchData           = this.fetchData.bind(this);
		this.getPagination       = this.getPagination.bind(this);
	}

	componentWillMount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.session.EC instanceof Object)
		{
			component.handleSessionChange();
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, config = this.props.config;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange ()
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC instanceof Object === false) return;

		if (state.EC_id !== app.state.session.EC.id)
		{
			component.fetchData(app.state.session.EC.id);
		}
	}

	fetchData (EC_id)
	{
		const component = this, props = this.props, state = this.state;

		component.setState({ loading: true });

		let filter_query =
		{
			EC: EC_id,
			sort: 'date DESC'
		};

		qwest.post('/CMS/getAll',
		{
			model: 'ECMeetingRecord'.toLowerCase(),
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,
				EC: EC_id,
				permissions: app.state.session.permissions.title,

				data: response.data.sort(function (a, b)
				{
					if (moment(a.date).isSame('day', b.date))
					{
						return 0;
					}
					else if (moment(a.date).isAfter(b.date))
					{
						return -1;
					}

					return 1;
				})
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false });

			app.ajaxRedirectLogin(response);
		});
	}

	getPagination ()
	{
		const component = this, props = this.props, config = this.props.config;

		let limit     = this.state.pagination.limit, skip = this.state.pagination.skip;
		let max_items = this.state.pagination.max_items;

		let total_items = component.state.data.length;

		let pagination = [];

		for (let i = 0; i < total_items; i += max_items)
		{
			let data =
			{
				items_count: (i + max_items > total_items) ? (total_items - i) : (max_items),
				skip: i
			};

			data.limit = i + data.items_count;

			pagination.push(data);
		}

		pagination = pagination.map(function (data, index)
		{
			let is_active = component.state.pagination.limit === data.limit;

			let output =
			(
				<div key={ index } className={ 'c-pagination-item' +
					(is_active ? ' c-pagination-item--active' : '') }
					onClick={ function () { setPagination(data); } }>
					{ index + 1 }
				</div>
			);

			return output;
		});

		return pagination;

		function setPagination (data)
		{
			let pagination = Object.assign({ }, component.state.pagination);

			pagination.limit = data.limit;
			pagination.skip  = data.skip;

			component.setState({ pagination: pagination });
		}
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['primary', 'bg-light', 'medium', 'MeetingRecords'] } />
			);
		}

		let records = state.data
		.filter(function (element, index)
		{
			if (props.pagination === false)
			{
				return true;
			}

			return index < state.pagination.limit && index >= state.pagination.skip;
		})
		.map(function (record, key)
		{
			let short_desc = stripTags((record.text || ''), [], ' ');

			short_desc = app.getTruncatedText(short_desc, 220, true);

			let output =
			(
				<div className="c-model-preview-item record o-grid__item u-flex"
					key={ record.id + key }>

					<div className="c-model-preview c-model-preview--record">

						<div className="c-model-preview__thumb">
							<Link className="c-model-preview__thumb-link"
								href={ '/accueil/mon-espace/comptes-rendus-de-reunion/' +
									record.id }>
								<svg className="o-svg-icon o-svg-icon--meeting_record c-model-preview__img icon">
									<use xlinkHref="/images/icons.svg#svg-icon-meeting_record"></use>
								</svg>
							</Link>
						</div>

						<h2 className="c-model-preview__title">
							<Link href={ '/accueil/mon-espace/comptes-rendus-de-reunion/' +
								record.id } className="c-model-preview__title-link">
								{ capitalize(moment(record.date).format('dddd')) }
								{ moment(record.date).format(' DD MMMM YYYY') }
							</Link>
						</h2>

						<div className="c-model-preview__infos">

							<div className="c-model-preview__description">
								{ short_desc }
							</div>

							<div className="c-model-preview__buttons">
								<Link href={ '/accueil/mon-espace/comptes-rendus-de-reunion/' +
									record.id } className="c-model-preview__link">
									<svg className="o-svg-icon o-svg-icon--eye c-model-preview__link-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
									</svg>Voir le compte rendu
								</Link>
							</div>

						</div>

					</div>

				</div>
			);

			return output;
		});

		let pagination = component.getPagination();

		if (!pagination || pagination.length <= 1)
		{
			pagination = undefined;
		}

		let add_btn;

		if (state.permissions === 'EC')
		{
			add_btn =
			(
				<div className="u-full-width u-text-right u-margin-bottom-20">
					<Link className="c-btn c-btn--extra" href="/accueil/mon-espace/nouveau-compte-rendu-de-reunion">
						Créer un compte rendu de réunion
					</Link>
				</div>
			);
		}

		var output =
		(
			<Layout history={ props.history } page_title="Comptes rendus de réunion">

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						{ add_btn }

						<div className="c-pagination u-margin-bottom-15">
							{ pagination }
						</div>

						<div className="u-negative-margin">

							<div className="o-grid-6 u-flex">
								{ loader || records }
							</div>

						</div>

						<div className="c-pagination u-margin-top-15">
							{ pagination }
						</div>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}
}